import { Col } from '@thd-olt-component-react/grid';
import { Carousel } from '@thd-olt-component-react/carousel';
import { LayoutGroup } from '@thd-olt-component-react/layout-manager';
import { RectShape, TextBlock } from '@thd-olt-component-react/loading-placeholder';
import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { bool, number, string } from 'prop-types';

const MOBILE_PLACEHOLDER_ITEM_COUNT = 3; // TODO: FIND OUT WHAT THIS SHOULD BE
const DESKTOP_PLACEHOLDER_ITEM_COUNT = 6; // TODO: FIND OUT WHAT THIS SHOULD BE
const MOBILE_PLACEHOLDER_TOTAL_HORIZONTAL_PADDING = 10;
const DESKTOP_PLACEHOLDER_TOTAL_HORIZONTAL_PADDING = 20;

const LoadingPlaceholder = ({
  scheme, itemClass, fixedItem, multiItem, itemWidthPixelsDesktop,
  itemWidthPixelsMobile, loadingLinesCount, loadingImageHeight
}) => {

  const { channel } = useContext(ExperienceContext);

  const isMobile = channel === 'mobile';

  const getTotalLoadingItems = () => {
    return isMobile ? MOBILE_PLACEHOLDER_ITEM_COUNT : DESKTOP_PLACEHOLDER_ITEM_COUNT;
  };

  const getStyle = (mobile = false) => {
    let style = {};

    if (mobile) {
      const width = itemWidthPixelsMobile;

      style = {
        width,
        height: loadingImageHeight || width * 1.2,
        marginRight: MOBILE_PLACEHOLDER_TOTAL_HORIZONTAL_PADDING,
        marginBottom: MOBILE_PLACEHOLDER_TOTAL_HORIZONTAL_PADDING,

      };
    } else {
      const width = itemWidthPixelsDesktop;

      style = {
        width,
        height: loadingImageHeight || width,
        marginRight: DESKTOP_PLACEHOLDER_TOTAL_HORIZONTAL_PADDING,
        marginBottom: DESKTOP_PLACEHOLDER_TOTAL_HORIZONTAL_PADDING,
      };
    }

    return style;
  };

  return (
    <>
      <Col>
        <div className="row-header">
          <div className="row-header__title">
            <h2 className="row-header__text">
              Loading Recommendations
            </h2>
          </div>
        </div>
      </Col>

      <Col xs="12">
        <Carousel
          name={scheme}
          id={scheme}
          itemClass={itemClass}
          fixedItem={fixedItem}
          multiItem={multiItem}
          itemWidthPixelsDesktop={itemWidthPixelsDesktop}
          itemWidthPixelsMobile={itemWidthPixelsMobile}
          showArrows={false}
          totalItems={getTotalLoadingItems()}
        >
          {[...Array(getTotalLoadingItems())].map((__, placeholder) => (
            <LayoutGroup key={placeholder} name={`product-pod-${placeholder}`}>
              <RectShape style={getStyle(isMobile)} color="#E0E0E0" />
              <TextBlock
                rows={loadingLinesCount}
                color="#E0E0E0"
                style={{ marginBottom: '1.5rem' }}
              />
            </LayoutGroup>
          ))}
        </Carousel>
      </Col>
    </>
  );
};

LoadingPlaceholder.propTypes = {
  fixedItem: bool,
  itemClass: string,
  multiItem: bool,
  itemWidthPixelsDesktop: number,
  itemWidthPixelsMobile: number,
  loadingImageHeight: number,
  loadingLinesCount: number,
  scheme: string
};

LoadingPlaceholder.defaultProps = {
  fixedItem: true,
  itemClass: '',
  multiItem: false,
  itemWidthPixelsDesktop: 220,
  itemWidthPixelsMobile: 150,
  loadingImageHeight: null,
  loadingLinesCount: 5,
  scheme: ''
};

export { LoadingPlaceholder };
